import { Button, Stack, Typography, useTheme } from '@mui/material';
import { FC, useState } from 'react';

import { medium } from '@styles/fontWeights';

type NotificationsCountProps = {
  numberOfNotifications: number;
  handleClick: () => void;
};

const NotificationsCount: FC<NotificationsCountProps> = ({
  numberOfNotifications,
  handleClick,
}) => {
  const [isTypographyShown, setIsTypographyShown] = useState(false);

  const theme = useTheme();

  if (!numberOfNotifications || numberOfNotifications <= 0) {
    return null;
  }

  return (
    <Stack
      spacing={1}
      direction="row"
      sx={{
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        zIndex: 1000,
      }}
    >
      {isTypographyShown && (
        <Typography color="error" variant="h6" fontWeight={medium}>
          Notifications
        </Typography>
      )}
      <Button
        color="error"
        variant="contained"
        size="small"
        onClick={handleClick}
        onMouseEnter={() => setIsTypographyShown(true)}
        onMouseLeave={() => setIsTypographyShown(false)}
        sx={{
          width: '30px',
          height: '30px',
          minWidth: '30px',
          borderRadius: '50%',
        }}
      >
        {numberOfNotifications > 99 ? '99+' : numberOfNotifications}
      </Button>
    </Stack>
  );
};

export default NotificationsCount;
